<template>
    <a href="https://www.asca.org/wp-content/uploads/2016/04/Articles-of-Incorporation.pdf" target="_blank">ASCA Articles of Incorporation</a>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({ name: "ASCAArtIncLink" });
</script>